export const PAYMENT_COUPON_FLOW_OPTIONS = [
  {
    value: 'qr_ars',
    labelTranslatedKey: 'paymentCoupon.flowOptions.qr_ars',
  },
  {
    value: 'pix',
    labelTranslatedKey: 'paymentCoupon.flowOptions.pix',
  },
  {
    value: 'cripto',
    labelTranslatedKey: 'paymentCoupon.flowOptions.cripto',
  },
  {
    value: 'qr_ars_promotion',
    labelTranslatedKey: 'paymentCoupon.flowOptions.qr_ars_promotion',
  },
];
